import { ChevronRight } from "lucide-react";
import { strings } from "../../../utils/constants/strings";
import {
  BannerLayout,
  ContentCenter,
  DesktopMain,
  WelcomeHeading,
  WelcomeSubtext,
  QuickActionPills,
  Pill,
} from "./styles.homepageDesktop";
import useHeroCarouselLogic from "./useHeroCarouselLogic";
import HomepageCenter from './HomepageCenter';
import Banner from "../../shared/Banner/Banner";

export default function HomePageDesktop({
  sellerName,
  checkAllPOs,
  checkPendingGRNs,
  handleManageUsersNavigate,
  bannerSlides = [],
  shouldShowHeroCarousel,
  navigate,
  handleGrnAndPaymentsClick,
}) {
  const {
    heroEmblaRef,
    selectedBannerIndex,
    bannerProgress,
    handleBannerDotClick,
    handleBannerClick,
  } = useHeroCarouselLogic(bannerSlides, { navigate, checkAllPOs, handleGrnAndPaymentsClick });

  return (
    <DesktopMain>
      {shouldShowHeroCarousel ? (
        <BannerLayout>
          <Banner
            bannerSlides={bannerSlides}
            heroEmblaRef={heroEmblaRef}
            selectedBannerIndex={selectedBannerIndex}
            bannerProgress={bannerProgress}
            handleBannerDotClick={handleBannerDotClick}
            handleBannerClick={handleBannerClick}
          />
        </BannerLayout>
      ) : null}
      <ContentCenter>
        <HomepageCenter />
        <WelcomeHeading>Welcome{sellerName ? ` ${sellerName}` : ""} 👋</WelcomeHeading>
        <WelcomeSubtext>
          {strings.homePageWelcomeSubtext}
        </WelcomeSubtext>
        <QuickActionPills>
          <Pill onClick={checkAllPOs}>
            {strings.homePagePillPurchaseOrders} <ChevronRight />
          </Pill>
          <Pill onClick={checkPendingGRNs}>
            {strings.homePagePillGrnAndPayments} <ChevronRight />
          </Pill>
          <Pill onClick={handleManageUsersNavigate}>
            {strings.homePagePillManageUsers} <ChevronRight />
          </Pill>
        </QuickActionPills>
      </ContentCenter>
    </DesktopMain>
  );
}
